<template>
  <div>
    <v-row>
      <v-col class="col4">
        <h2>Previous quotations for this customer</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col12">
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Job No</th>
                <th class="text-left">
                  <span class="link" @click="reorderDate">Date</span>
                </th>
                <th class="text-left">Site</th>
                <th class="text-left">Value</th>
                <th class="text-left">Status</th>
                <th class="text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="quotation in orderedQuotations"
                :key="quotation.id"
              >
                <td>{{ quotation.jobNumber }}</td>
                <td>{{ quotation.created | tinyDate }}</td>
                <td>{{ quotation.site_location }}</td>
                <td>{{ quotation.total_value | priceInPounds | currency }}</td>
                <td>{{ quotation.status }}</td>
                <td>
                  <router-link custom v-slot="{ navigate }" :to="`/quotations/view/${quotation.id}`">
                    <v-btn
                      x-small
                      @click="navigate"
                      @keypress.enter="navigate"
                      role="link">
                      View
                    </v-btn>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'CustomerInfoQuotes',
  props: [
    'quotations',
  ],
  computed: {
    orderedQuotations() {
      return this.quotations;
    },
  },
  methods: {
    reorderDate() {
      const reOrdered = this.orderedQuotations.reverse();
      this.orderedQuotations = reOrdered;
    },
  },
};
</script>
